export default "__VITE_ASSET__BuuBVk5r__"